import React, { useEffect, useMemo, useState } from 'react'
import { ReactComponent as Sofa } from './icons/sofa.svg'
import InfoModal, { PackageInfoContent } from '../../DesignPicker/InfoModal'
import useDetectDevice from '../../../../../hooks/useDetectDevice'
import BottomSheet from '../../../../BottomSheet'
import { captureEvent } from '../../../../../analytics'
import { analyticsEvents } from '../../../../../analytics/events'
function TVPackageInfo({ className = '',selectedPackage, selectedLine, onShown = () => {} }) {
  const [infoShown, setInfoShown] = useState(false)
  const count = useMemo(() => {
    if (selectedPackage) {
      const wares = selectedPackage.room_classifications.filter(r=>['kitchenware', 'bathware'].includes(r.room_classification.classification_name.toLowerCase()))
      const other = selectedPackage.room_classifications.filter(r=>!['kitchenware', 'bathware'].includes(r.room_classification.classification_name.toLowerCase()))

      return `${other.map((r) => (r.categories || '').split(',')).flat().length}${wares.length > 0 ? '+' : ''}`
    }
    return 0
  }, [selectedPackage])

  useEffect(()=>{
    setInfoShown(false)
  }, [selectedLine])
  
  useEffect(()=>{
    onShown && onShown(infoShown)
  }, [onShown, infoShown])

  const { isMobile, isDesktop, isMobileLandscape } = useDetectDevice()

  return (
    <>
      <>
        {isDesktop && (
          <>
            {infoShown && (
              <InfoModal
                count={count}
                pack={selectedPackage}
                onClose={() => {
                  captureEvent(analyticsEvents.PACKAGE_INFO_CLOSED)
                  setInfoShown(null)
                }}
              />
            )}
          </>
        )}
        {isMobile && (
          <BottomSheet
          transparentOverlay
          closeOnClickOutside
          scrollResetContent={selectedPackage.id}
            spaceFromTop={isMobileLandscape ? 60 : 170}
            open={infoShown}
            onToggle={() => {
              setInfoShown(false)
            }}
          >
            <PackageInfoContent pack={selectedPackage} count={count} />
          </BottomSheet>
        )}
      </>
      <button
        type="button"
        className={`bg-white shadow-md h-[64px] rounded-[4px] relative flex items-center ${className}`}
        onClick={() => {
          captureEvent(analyticsEvents.PACKAGE_INFO_TAPPED)
          setInfoShown(true)
        }}
      >
        <div className="px-[12px] text-[28px] flex items-center font-medium"><span className='inline-block px-[24px]  truncate' title={`${count} Items`}>{count} Items</span></div>
        <span className="h-full border-l-[1px] px-[24px] border-[#C7CCD9] border-solid  items-center justify-center  flex">
          <Sofa />
        </span>
      </button>
    </>
  )
}

export default TVPackageInfo
